export default "__VITE_ASSET__DY0XsM6R__"